module.exports = __webpack_public_path__ + "static/media/crown_touch.36537d60.jpg";